import * as actionTypes from './ActionTypes';

export const updateSelectedLab = (labId) => {
    return (dispatch) => {
        dispatch(onLabSelection(labId))
    }
}

const onLabSelection = (labId) => {
    return {
        type: actionTypes.STUDENT_UPDATE_SELECTED_LAB,
        payload: {
            data: labId
        }
    }
}
//============================================================//
export const updateSelectedProgram = (programId) => {
    return (dispatch) => {
        dispatch(onProgramSelection(programId))
    }
}

const onProgramSelection = (programId) => {
    return {
        type: actionTypes.STUDENT_UPDATE_SELECTED_PROGRAM,
        payload: {
            data: programId
        }
    }
}
//=============================================================//
export const updateSelectedSubmission = (submissionId) => {
    return (dispatch) => {
        dispatch(onSubmissionSelection(submissionId))
    }
}

const onSubmissionSelection = (submissionId) => {
    return {
        type: actionTypes.STUDENT_UPDATE_SELECTED_SUBMISSION,
        payload: {
            data: submissionId
        }
    }
}

//
//following method is not a correct method
// it was added to remove the module not found error
export const updateSelectedCourse = (courseId) => {
    return (_dispatch) => {
        
    }
}